import { render, staticRenderFns } from "./BillDetailHeader.vue?vue&type=template&id=473315ac&scoped=true"
import script from "./BillDetailHeader.vue?vue&type=script&lang=ts"
export * from "./BillDetailHeader.vue?vue&type=script&lang=ts"
import style0 from "./BillDetailHeader.vue?vue&type=style&index=0&id=473315ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473315ac",
  null
  
)

export default component.exports